import React from "react";
import CustomButton from "./CustomButton";

const PageLayout = ({
  title,
  subtitle,
  children,
  onBack,
  onSubmit,
  backText = "Back",
  submitText = "Create",
  loading = false,
  actions,
}) => {
  return (
    <div className="page-layout">
      {/* Optional Header */}
      {title && (
        <div className="page-header">
          <h1 className="page-title">
            <span className="page-title-bar"></span>
            {title}
          </h1>

          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
      )}

      {/* Scrollable Main Content */}
      <div className="page-content">{children}</div>

      {/* Fixed Bottom Action Bar */}
      {(onBack || onSubmit || actions) && (
        <div className="page-actions">
          {actions ? (
            actions
          ) : (
            <>
              {onBack ? (
                <CustomButton
                  label={backText}
                  variant="outline"
                  className="back-button"
                  onClick={onBack}
                />
              ) : (
                // <button
                //   type="button"
                //   onClick={onBack}
                //   className="back-button"
                // >
                //   {backText}
                // </button>
                <div />
              )}

              {onSubmit && (
                <CustomButton
                  label={loading ? "Saving..." : submitText}
                  variant="solid"
                  className="submit-button"
                  onClick={onSubmit}
                />

                // <button
                //   type="button"
                //   onClick={onSubmit}
                //   disabled={loading}
                //   className="submit-button"
                // >
                //   {loading ? "Saving..." : submitText}
                // </button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PageLayout;
